<template>
  <div class="ExtraWorkArchive">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row class="mt-2">
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("fromDate") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker :label="$t('fromDate') + ':'" :initDate="initBeginDate" @dateResult="bDate" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="mt-2 mt-sm-0">
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("toDate") }} : </label>
              </v-col>
              <v-col>
                <dialog-date-picker :label="$t('toDate') + ':'" :initDate="initEndDate" @dateResult="eDate" />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row class="mt-2">
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("requestType") }} : </label>
              </v-col>
              <v-col>
                <v-select hide-details v-model="requestType" :items="requestTypes" :label="$t('requestType')"
                  item-text="Name" item-value="Code" return-object dense solo v-on:change="changeRequestType"
                  class="my-auto py-0"></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>

          <v-btn class="px-5" color="primary" :loading="isLoading" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>

    <box class="mt-2" :title="$t('extraWorkList')">
      <div class="extraWorkList pb-1">
        <div v-if="list.length > 0">
          <v-alert class="ma-2" dense border="left" colored-border color="green" elevation="2"
            icon="mdi-alert-circle-outline">
            <div class="text-small">
              توجه : سطر های سبز رنگ برگه های اضافه کار گروهی هستند و ممکن است
              در شرایط تمام درخواست ها مشاهده نشوند.
            </div>
          </v-alert>
          <person-extra-work-list-web :pagination="true" @onClick="onClickEW" :list="list" class="hidden-sm-and-down" />
          <person-extra-work-list-mob @onClick="onClickEW" :list="list" class="hidden-md-and-up" />

          <!-- <div class="text-center">
            <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="5"
              @input="search"
            ></v-pagination>
          </div> -->
        </div>
        <div v-else>
          <EmptyList />
        </div>
      </div>
    </box>

    <extra-work-archive-details class="mt-2" ref="ArchiveDetails" @refresh="search" />
  </div>
</template>

<script>
import ExtraWorkArchiveDetails from "../../components/request/ExtraWorkArchiveDetails.vue";
import PersonExtraWorkListMob from "../../components/request/PersonExtraWorkList/PersonExtraWorkListMob.vue";
import PersonExtraWorkListWeb from "../../components/request/PersonExtraWorkList/PersonExtraWorkListWeb.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import EosToastType from "../../model/EosToastType";
import type from "../../model/IORequestType";
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    DialogDatePicker,
    PersonExtraWorkListWeb,
    PersonExtraWorkListMob,
    ExtraWorkArchiveDetails,
  },
  data() {
    return {
      pages: 1,
      page: 1,
      pagesize: 20,
      requestTypes: [],
      requestType: "",
      isLoading: false,
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      list: [],
    };
  },
  mounted() {
    var moment = require("jalali-moment");
    var year = moment().locale("fa").format("YYYY");
    this.initBeginDate = year + "/01/01";

    this.initEndDate = moment().locale("fa").endOf("year").format("YYYY/MM/DD");

    this.requestTypes = type.IORequestTypeArray();
    if (this.requestTypes.length > 0) {
      this.requestType = this.requestTypes[0];
    }
  },
  methods: {
    bDate(date) {
      this.beginDate = date;
      this.search();
    },
    eDate(date) {
      this.endDate = date;
      this.search();
    },
    changeRequestType() {
      this.search();
    },
    search() {
      //debugger;
      if (!this.beginDate || !this.endDate) {
        return;
      }
      this.hideDetails();
      if (this.requestType.Code == 2) {
        this.requestType.Code = 5
      }
      else if (this.requestType.Code == 5) {
        this.requestType.Code = 2
      }

      var GetExtraWorkParams = {
        beginDate: this.beginDate,
        endDate: this.endDate,
        status: this.requestType.Code,
        page: this.page,
        pagesize: this.pagesize,

      };
      //params.append("searchKind", this.requestType.Code);
      //debugger
      this.$store
        .dispatch("GetExtraWork", { GetExtraWorkParams })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            // if (result.response.TotalRow) {
            //   this.pages = Math.ceil(result.response.TotalRow / this.pagesize);
            //   //console.log(this.pages);
            // }
            //debugger
            this.list = result.data;
            //this.getFilteredList(result.data);
          } else {
            this.list = [];
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
        });
    },
    getFilteredList(list) {
      this.list = [];
      switch (this.requestType.Code.toString()) {
        case "1":
          //result = " status <> 1  AND status <> 10 AND status <> 11 ";
          this.list = list.filter(
            (item) =>
              item.status.toString() !== "1" &&
              item.status.toString() !== "10" &&
              item.status.toString() !== "11"
          );
          break;
        case "2":
          //result = " status = 10 ";
          this.list = list.filter((item) => item.status.toString() === "10");
          break;
        case "3":
          //result = " status = 1 ";
          this.list = list.filter((item) => item.status.toString() === "1");
          break;
        case "4":
          //result = " status = 2 ";
          this.list = list.filter((item) => item.status.toString() === "2");
          break;
        case "7":
          //result = " status = 11 ";
          this.list = list.filter((item) => item.status.toString() === "11");
          break;
        case "5":
          //result = "1 = 1";
          this.list = list;
          break;
      }
    },
    onClickEW(item) {
      //console.log(item);
      this.hideDetails();
      const params = new URLSearchParams();
      params.append("pageno", TextUtils.convertToEnglishDigits(item.pageNO));
      params.append("dbkind", item.DBKIND);
      params.append("year", item.YEAR);
      params.append("isGetForEdit", false);

      this.$store.dispatch("GetExtraWorkDetail", { params }).then((result) => {
        //console.log(result);
        if (result.type == "success") {
          if (result.data.Table.length > 0) {
            let details = result.data.Table[0];
            this.$refs.ArchiveDetails.show(item, details);
          }
        }
      });
    },
    hideDetails() {
      this.$refs.ArchiveDetails.hide();
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  width: 100px;
}
</style>